module.exports = __webpack_public_path__ + "img/p2.af5b6495.jpg";